import React, { useState, useEffect } from 'react';

interface EditHomeworkModalProps {
  homeworkId?: string;
}

const EditHomeworkModal: React.FC<EditHomeworkModalProps> = ({ homeworkId }) => {
  const [formData, setFormData] = useState({
    title: '',
    subject: '',
    class: '',
    description: '',
    dueDate: '',
    priority: 'medium',
    status: 'active'
  });

  // TODO: Fetch homework data when modal opens
  useEffect(() => {
    if (homeworkId) {
      // Mock data - replace with API call
      setFormData({
        title: 'Math Chapter 5 - Algebra',
        subject: 'mathematics',
        class: 'grade-9',
        description: 'Complete exercises 1-15 from Chapter 5. Show all working steps.',
        dueDate: '2024-12-30',
        priority: 'high',
        status: 'active'
      });
    }
  }, [homeworkId]);

  const handleSubmit = () => {
    // TODO: Update homework API call
    console.log('Updating homework:', formData);
  };

  return (
    <div className="modal fade" id="editHomeworkModal">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Homework</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Title <span className="text-danger">*</span></label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={formData.title}
                    onChange={(e) => setFormData({...formData, title: e.target.value})}
                    placeholder="Enter homework title"
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Subject <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    required
                  >
                    <option value="">Select Subject</option>
                    <option value="mathematics">Mathematics</option>
                    <option value="english">English</option>
                    <option value="science">Science</option>
                    <option value="history">History</option>
                    <option value="geography">Geography</option>
                    <option value="physics">Physics</option>
                    <option value="chemistry">Chemistry</option>
                    <option value="biology">Biology</option>
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Class <span className="text-danger">*</span></label>
                  <select 
                    className="form-select"
                    value={formData.class}
                    onChange={(e) => setFormData({...formData, class: e.target.value})}
                    required
                  >
                    <option value="">Select Class</option>
                    <option value="grade-1">Grade 1</option>
                    <option value="grade-2">Grade 2</option>
                    <option value="grade-3">Grade 3</option>
                    <option value="grade-4">Grade 4</option>
                    <option value="grade-5">Grade 5</option>
                    <option value="grade-6">Grade 6</option>
                    <option value="grade-7">Grade 7</option>
                    <option value="grade-8">Grade 8</option>
                    <option value="grade-9">Grade 9</option>
                    <option value="grade-10">Grade 10</option>
                    <option value="grade-11">Grade 11</option>
                    <option value="grade-12">Grade 12</option>
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Due Date <span className="text-danger">*</span></label>
                  <input 
                    type="date" 
                    className="form-control"
                    value={formData.dueDate}
                    onChange={(e) => setFormData({...formData, dueDate: e.target.value})}
                    required
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Status</label>
                  <select 
                    className="form-select"
                    value={formData.status}
                    onChange={(e) => setFormData({...formData, status: e.target.value})}
                  >
                    <option value="active">Active</option>
                    <option value="draft">Draft</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Priority</label>
                <select 
                  className="form-select"
                  value={formData.priority}
                  onChange={(e) => setFormData({...formData, priority: e.target.value})}
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea 
                  className="form-control"
                  rows={4}
                  value={formData.description}
                  onChange={(e) => setFormData({...formData, description: e.target.value})}
                  placeholder="Enter homework description and instructions..."
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Update Attachments</label>
                <input 
                  type="file" 
                  className="form-control" 
                  multiple 
                  accept=".pdf,.doc,.docx,.txt,.jpg,.png"
                />
                <small className="text-muted">Leave empty to keep existing attachments</small>
              </div>
              <div className="mb-3">
                <h6>Options</h6>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="extendDeadline" />
                  <label className="form-check-label" htmlFor="extendDeadline">
                    Extend deadline for all students
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="notifyStudents" />
                  <label className="form-check-label" htmlFor="notifyStudents">
                    Notify students about changes
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="allowResubmission" />
                  <label className="form-check-label" htmlFor="allowResubmission">
                    Allow resubmission
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-cancel" data-bs-dismiss="modal">
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
              <i className="ti ti-device-floppy me-2"></i>Update Homework
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHomeworkModal;
